// extracted by mini-css-extract-plugin
module.exports = {"copyright-policy":"copyright-policy_copyright-policy__nzjUg"};